import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { GroupingTypeOfVariableService } from '../proxy/controlling/controllers/grouping-type-of-variable.service';

FieldBuilder.setNamespace('Controlling');

export const VARIABLETYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.VariableType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.VariableType.Code')
    .required()
    .minLength(1)
    .maxLength(25)
    .build(),
  FieldBuilder
    .foreignKey('groupingTypeOfVariableId', 'Entity.GroupingTypeOfVariable', GroupingTypeOfVariableService)
    .displayFromNested('groupingTypeOfVariable.name')
    .sortBy('groupingTypeOfVariable.name')
    .build(),
];

export const VARIABLETYPE_CONFIG = {
  entityName: 'VariableType',
  localizationKey: 'Controlling::Entity.VariableType',
  fields: VARIABLETYPE_FIELDS,
  permission: 'ControllingLiquidations.VariableTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
